<main *ngIf="rotaCarregada">
  <section *ngIf="usuarioEstaLogado" [ngClass]="appService.tema">

    <app-nav></app-nav>
    <app-side-menu></app-side-menu>

    <main class="body" [class.menu-shown]="this.appService.sideBarEstaVisivel">
      <router-outlet></router-outlet>
    </main>

  </section>

  <app-modal-login *ngIf="!usuarioEstaLogado"></app-modal-login>

</main>